//import { Button } from '@mui/material'
import { Button } from '@nextui-org/react'
import cn from 'classnames'
import { useTheme } from 'next-themes'
import { useTranslation } from 'react-i18next'
const VolumeTypeSelection = ({ volumeType, selectVolumeType }) => {
    const { t } = useTranslation('common')

    const renderButton = (text, value) => {
        return (
            <div className="m-auto mr-2 w-36 md:w-24">
                <Button
                    radius="sm"
                    fullWidth
                    variant={volumeType === value ? 'solid' : 'bordered'}
                    onClick={() => {
                        volumeType !== value ? selectVolumeType(value) : null
                    }}
                    color={'primary'}
                    className={cn(
                        volumeType === value
                            ? 'bg-primary text-black'
                            : 'dark:!bg-papert bg-white text-primary',
                    )}
                >
                    {text}
                </Button>
            </div>
        )
    }

    return (
        <div className={cn('flex flex-wrap justify-center md:justify-start')}>
            {renderButton(t('buttons.all'), 'all')}
            {renderButton(t('buttons.sales'), 'sales')}
            {renderButton(t('navigation.drops'), 'drops')}
        </div>
    )
}

export default VolumeTypeSelection
